export default __webpack_public_path__ + "static/media/services_trans_0.74810af5.jpg";